import { ReactNode } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import WarningIcon from '@mui/icons-material/Warning';
import {
  AppKeys,
  AppStatuses,
  LocationKeys,
  LocStatusTemplate,
  OverallStatus,
  ServerStatus,
} from './types';
import { DOMAIN } from '../api/api-consts';

export const MAX_VIEW_WIDTH = 1280;
export const MIN_VIEW_WIDTH = 280;
export const HEADER_HEIGHT = 100;

export const TECH_OPS_EMAIL = 'status@braincorp.com';

// ordered according to Figma documentation
export const LOCATION_KEYS = ['apac', 'eur', 'sa', 'usa'] as const;

export const APP_KEYS = ['admin', 'emails', 'portal', 'tours', 'www'] as const;

export const HEADER_MESSAGE_BY_STATUS: Record<OverallStatus, string> = {
  good: 'BrainOS is up and running',
  bad: 'BrainOS is experiencing issues',
  unknown: 'Unknown Status',
};

export const LOCATION_DISPLAY_NAMES: Record<LocationKeys, string> = {
  usa: 'North America',
  eur: 'Europe',
  apac: 'Asia',
  sa: 'South America',
};

export const APP_DISPLAY_NAMES: Record<AppKeys, string> = {
  admin: 'Admin Console',
  emails: 'Email Reports',
  portal: 'Portal',
  tours: 'Virtual Tours',
  www: 'BrainOS Hub',
};

export const APP_HYPERLINKS: Record<AppKeys, string> = {
  admin: `https://admin.brainos.${DOMAIN}`,
  emails: `https://emails.brainos.${DOMAIN}`,
  portal: `https://portal.brainos.${DOMAIN}`,
  tours: `https://tours.brainos.${DOMAIN}`,
  www: `https://www.brainos.${DOMAIN}`,
};

export const STATUS_ICONS: Record<ServerStatus, ReactNode> = {
  pass: <CheckCircleIcon color="success" />,
  fail: <DoNotDisturbOnIcon color="error" />,
  unknown: <WarningIcon color="warning" />,
};

export const INIT_STATUS_BY_LOCATION: LocStatusTemplate = {
  usa: 'unknown',
  eur: 'unknown',
  apac: 'unknown',
  sa: 'unknown',
};

export const INIT_APP_STATUSES: AppStatuses = {
  admin: {
    usa: 'unknown',
    eur: 'unknown',
    apac: 'unknown',
    sa: 'unknown',
  },
  emails: {
    usa: 'unknown',
    eur: 'unknown',
    apac: 'unknown',
    sa: 'unknown',
  },
  portal: {
    usa: 'unknown',
    eur: 'unknown',
    apac: 'unknown',
    sa: 'unknown',
  },
  tours: {
    usa: 'unknown',
    eur: 'unknown',
    apac: 'unknown',
    sa: 'unknown',
  },
  www: {
    usa: 'unknown',
    eur: 'unknown',
    apac: 'unknown',
    sa: 'unknown',
  },
};
